import { CartServiceBase } from '@/services/cart/CartServiceBase';
import { FairCartApiWrapper } from '@/services/cart/api/FairCartApiWrapper';
import { OrderDto } from '@eurogast/hub-client-typescript';
import Store from '@/store';
import { ConfigService } from '@/services/ConfigService';

export class FairCartService extends CartServiceBase {
  protected api: FairCartApiWrapper;

  public constructor(fairCode: string) {
    super(new FairCartApiWrapper(fairCode));
  }

  protected submitOrder(): Promise<OrderDto> {
    const orderState = Store.state.commonOrderDetail;
    const fairOrderState = Store.state.fairOrderDetail;

    return this.api.submitOwnShoppingCart(
      ConfigService.getTenant(),
      ConfigService.currentCustomerId,
      {
        deliveryAddressExternalId: orderState.deliveryAddress.externalId,
        unloadingArea: orderState.unloadingArea,
        notes: orderState.notes,
        customerOrderId: orderState.customerOrderId,
        requestedDeliveryDay: this.parseDate(fairOrderState.requestedDeliveryDay),
        requestedDeliveryDayFreshProducts: this.parseDate(fairOrderState.requestedDeliveryDayFreshProducts)
      }
    );
  }

  private parseDate(date: Date): (string | null) {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return year + '-' + month + '-' + day;
  }
}
